"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumanFigure = void 0;
var HumanFigure;
(function (HumanFigure) {
    /**
     * Convert object figure to string
     * @param figure Figure Dictionary
     */
    function encode(figure) {
        return Object.keys(figure)
            .map(f => [f, figure[f].id, ...(figure[f].colors || [])].join('-'))
            .join('.');
    }
    HumanFigure.encode = encode;
    /**
     * Convert string to figure object
     * @param figure Figure String
     */
    function decode(figure) {
        return figure
            .split('.')
            .map(part => part.split('-'))
            .reduce((obj, [type, id, ...colors]) => (Object.assign(Object.assign({}, obj), { [type]: { id, colors } })), {});
    }
    HumanFigure.decode = decode;
    function getLib(figuremap, type, id) {
        var _a;
        const libraryIndex = figuremap.parts[type][id];
        const lib = (_a = figuremap.libs[libraryIndex]) === null || _a === void 0 ? void 0 : _a.id;
        if (!lib) {
            if (type === 'hrb') {
                return getLib(figuremap, 'hr', id);
            }
            if (type === 'ls' || type === 'rs') {
                return getLib(figuremap, 'ch', id);
            }
        }
        return lib;
    }
    HumanFigure.getLib = getLib;
    function isFromPartSet(partsets, partSet, partType) {
        return new Set(partsets.activePartSets[partSet]).has(partType);
    }
    HumanFigure.isFromPartSet = isFromPartSet;
})(HumanFigure = exports.HumanFigure || (exports.HumanFigure = {}));
